let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6FmR0")).then(() => parcelRequire('2y4Ff'));